import React, { useState, useEffect, useCallback } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import '../styles/Testimonial.scss';

// Import review images
import Review1 from '../images/reviews/1.png';
import Review2 from '../images/reviews/2.png';
import Review3 from '../images/reviews/3.png';
import Review4 from '../images/reviews/4.png';

const Testimonials = () => {
  const reviews = [
    { id: 1, image: Review1, alt: 'Parent Review for Prabhat Tara Vidya Niketan 1' },
    { id: 2, image: Review2, alt: 'Parent Review for Prabhat Tara Vidya Niketan 2' },
    { id: 3, image: Review3, alt: 'Parent Review for Prabhat Tara Vidya Niketan 3' },
    { id: 4, image: Review4, alt: 'Parent Review for Prabhat Tara Vidya Niketan 4' }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const totalPages = Math.ceil(reviews.length / 2);

  const nextSlide = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % totalPages);
  }, [totalPages]);

  const prevSlide = useCallback(() => {
    setCurrentIndex((prev) => (prev - 1 + totalPages) % totalPages);
  }, [totalPages]);

  const getVisibleReviews = () => {
    const startIndex = currentIndex * 2;
    return reviews.slice(startIndex, startIndex + 2);
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 6000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <div className="section-header">
          <span className="section-tag-light">
            <Star size={14} /> Community Trust
          </span>
          <h2>What Parents & Students Say</h2>
          <p>Real experiences and verified reviews from families across Goraul and Vaishali.</p>
        </div>

        <div className="testimonial-slider">
          <button 
            className="nav-btn nav-btn-prev" 
            onClick={prevSlide}
            aria-label="Previous testimonials"
          >
            <ChevronLeft size={24} />
          </button>

          <div className="testimonial-content">
            {getVisibleReviews().map((review) => (
              <div key={review.id} className="review-image-container">
                <img 
                  src={review.image} 
                  alt={review.alt} 
                  className="review-image" 
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          <button 
            className="nav-btn nav-btn-next" 
            onClick={nextSlide}
            aria-label="Next testimonials"
          >
            <ChevronRight size={24} />
          </button>
        </div>

        <div className="review-indicator">
          {Array.from({ length: totalPages }).map((_, index) => (
            <button 
              key={index} 
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
